import axios from "axios";
import {
  TRANSACTION_LIST_REQUEST,
  TRANSACTION_LIST_SUCCESS,
  TRANSACTION_LIST_FAIL,
  TRANSACTION_STATS_REQUEST,
  TRANSACTION_STATS_SUCCESS,
  TRANSACTION_STATS_FAIL,
  TRANSACTION_INCOMPLETE_REQUEST,
  TRANSACTION_INCOMPLETE_SUCCESS,
  TRANSACTION_INCOMPLETE_FAIL,
  ORDER_TRANSACTION_REQUEST,
  ORDER_TRANSACTION_SUCCESS,
  ORDER_TRANSACTION_FAIL,
  TRANSACTION_SINGLE_REQUEST,
  TRANSACTION_SINGLE_SUCCESS,
  TRANSACTION_SINGLE_FAIL,
  CREATE_TRANSACTION_REQUEST,
  CREATE_TRANSACTION_SUCCESS,
  CREATE_TRANSACTION_FAIL,
  MPESA_STK_TRANSACTION_REQUEST,
  MPESA_STK_TRANSACTION_SUCCESS,
  MPESA_STK_TRANSACTION_FAIL,
  UPDATE_TRANSACTION_REQUEST,
  UPDATE_TRANSACTION_SUCCESS,
  UPDATE_TRANSACTION_FAIL,
  DELETE_TRANSACTION_REQUEST,
  DELETE_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION_FAIL,
} from "constants/transactionConstants";
import { REACT_APP_API_URL } from "constants/apiConstants";
import TransactionsService from "services/transactions-service";
import { getOrderSingle } from "./orderActions";

export const getTransactionList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: TRANSACTION_LIST_REQUEST,
    });

    const res = await TransactionsService.getTransactions();
    console.log(
      "🚀 ~ file: transactionActions.js:24 ~ getTransactionList ~ res:",
      res
    );

    dispatch({
      type: TRANSACTION_LIST_SUCCESS,
      payload: res.foundTransactions,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: transactionActions.js:27 ~ getTransactionList ~ error:",
      error
    );
    dispatch({
      type: TRANSACTION_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getStatsTransactions = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: TRANSACTION_STATS_REQUEST,
    });

    const res = await TransactionsService.getTransactionsStats();
    console.log(
      "🚀 ~ file: transactionActions.js:67 ~ getTransactionStats ~ res:",
      res
    );

    dispatch({
      type: TRANSACTION_STATS_SUCCESS,
      payload: res.result,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: transactionActions.js:74 ~ getTransactionStats ~ error:",
      error
    );
    dispatch({
      type: TRANSACTION_STATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getIncompleteTransactions = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: TRANSACTION_INCOMPLETE_REQUEST,
    });

    const res = await TransactionsService.getIncompleteTransactions();
    console.log(
      "🚀 ~ file: transactionActions.js:100 ~ getIncompleteTransactions ~ res:",
      res
    );

    dispatch({
      type: TRANSACTION_INCOMPLETE_SUCCESS,
      payload: res.foundTransactions,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: transactionActions.js:107 ~ getIncompleteTransactions ~ error:",
      error
    );
    dispatch({
      type: TRANSACTION_INCOMPLETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getOrderTransaction = (orderId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ORDER_TRANSACTION_REQUEST,
    });

    const res = await axios.get(
      `${REACT_APP_API_URL}/admin/transactions/order/${orderId}/`
    );

    var response = res.data;

    const changeDate = (a) => new Date(a).toLocaleDateString();

    const result = response.map((r) => ({
      ...r,
      created_at: changeDate(r.created_at),
    }));

    dispatch({
      type: ORDER_TRANSACTION_SUCCESS,
      payload: result,
    });
  } catch (error) {
    dispatch({
      type: ORDER_TRANSACTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getSingleTransaction =
  (transactionId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: TRANSACTION_SINGLE_REQUEST,
      });

      const res = await TransactionsService.getSingleTransaction(transactionId);
      console.log("🚀 ~ file: transactionActions.js:98 ~ res:", res);

      dispatch({
        type: TRANSACTION_SINGLE_SUCCESS,
        payload: res.foundTransaction,
      });
    } catch (error) {
      console.log("🚀 ~ file: transactionActions.js:105 ~ error:", error);
      dispatch({
        type: TRANSACTION_SINGLE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const newTransactionCreate =
  (transaction) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_TRANSACTION_REQUEST,
      });

      const res = await TransactionsService.createNewTransaction(transaction);
      console.log("🚀 ~ file: transactionActions.js:124 ~ res:", res);
      dispatch(getOrderSingle(transaction?.order));
      dispatch(getTransactionList());
      dispatch(getStatsTransactions());
      dispatch(getIncompleteTransactions());

      dispatch({
        type: CREATE_TRANSACTION_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: transactionActions.js:131 ~ error:", error);
      dispatch({
        type: CREATE_TRANSACTION_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const mpesaStkTransactionCreate =
  (transaction) => async (dispatch, getState) => {
    try {
      dispatch({
        type: MPESA_STK_TRANSACTION_REQUEST,
      });

      const res = await TransactionsService.mpesaStkNewTransaction(transaction);
      console.log("🚀 ~ file: transactionActions.js:223 ~ res:", res);
      dispatch(getTransactionList());
      dispatch(getStatsTransactions());
      dispatch(getIncompleteTransactions());

      dispatch({
        type: MPESA_STK_TRANSACTION_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: transactionActions.js:234 ~ error:", error);
      dispatch({
        type: MPESA_STK_TRANSACTION_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const updatingTransaction =
  (transactionId, transaction) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_TRANSACTION_REQUEST,
      });

      const res = await TransactionsService.editTransaction(
        transactionId,
        transaction
      );
      console.log("🚀 ~ file: transactionActions.js:153 ~ res:", res);
      dispatch(getTransactionList());
      dispatch(getStatsTransactions());
      dispatch(getIncompleteTransactions());

      dispatch({
        type: UPDATE_TRANSACTION_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: transactionActions.js:160 ~ error:", error);
      dispatch({
        type: UPDATE_TRANSACTION_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const deleteTransaction =
  (transactionId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: DELETE_TRANSACTION_REQUEST,
      });

      const res = await TransactionsService.getTransactions(transactionId);

      dispatch({
        type: DELETE_TRANSACTION_SUCCESS,
        payload: res,
      });
    } catch (error) {
      dispatch({
        type: DELETE_TRANSACTION_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };
